const baseURL2 = "https://erp.newfriendsjewellers.com:8080";


export default baseURL2;